import { html } from "uhtml";
import { Customised } from "../custom-element.js";
import { locale, pageNumber } from "../../view-models/app-signals.js";
import { locales } from "../../models/locales.js";
import {
	bookmarksList,
	deleteBookmarkLocator,
	saveBookmarkLocator,
} from "../../view-models/bookmarks-signals.js";
import { pageToLocator } from "../../models/Locator.js";
import { pageCount } from "../../view-models/page-signals.js";

export class CassisBookmarksList extends Customised(HTMLElement) {
	static tagName = "cassis-bookmarks-list";
	signals() {
		const list = bookmarksList();
		return { list, locale: locale() };
	}
	render({ list }) {
		return html`<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" role="img" class="svgIcon use">
  <defs>
    <symbol id="del-icon" viewBox="0 0 19 19">
      <title>${locales.delete[locale]}</title>
      <path d="M11.524.909H7.478c-.646 0-1.171.524-1.171 1.171v.889H2.683c-.675 0-1.225.549-1.225 1.226v.613c0 .676.549 1.226 1.225 1.226h.527l.001 10.281c0 .979.797 1.776 1.777 1.776h9.025c.98 0 1.777-.797 1.777-1.776V6.033h.527c.675 0 1.224-.549 1.224-1.226v-.613c0-.676-.549-1.226-1.224-1.226h-3.623V2.08a1.17 1.17 0 00-1.17-1.171zM6.915 2.08c0-.311.253-.563.562-.563h4.048c.311 0 .562.253.562.563v.889H6.914l.001-.889zm8.27 14.234a1.17 1.17 0 01-1.17 1.169H4.989a1.17 1.17 0 01-1.169-1.169L3.819 6.032h11.365v10.282h.001zm1.134-12.737c.34 0 .615.276.615.617v.613a.616.616 0 01-.615.617H2.683a.616.616 0 01-.616-.617v-.613c0-.341.275-.617.616-.617h13.636z"></path><path d="M12.495 16.065a.305.305 0 00.304-.305V7.75a.304.304 0 10-.608 0v8.011a.303.303 0 00.304.304z"></path><path d="M9.501 16.065a.305.305 0 00.304-.305V7.75a.305.305 0 00-.608 0v8.011c0 .169.136.304.304.304z"></path><path d="M6.508 16.065a.305.305 0 00.304-.305V7.75a.305.305 0 00-.608 0v8.011c0 .169.136.304.304.304z"></path>
    </symbol>
  </defs>
</svg><ol>
	${list.map((item) => {
		const href = `#page=${item.page}`;
		return html`<li><a href="${href}" data-id="">Page ${item.page}</a><button role="button" class="del-button" @click="${() => {
			deleteBookmarkLocator(item.page);
		}}"><svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" class="icon del-icon" role="img" aria-labelledby="del-icon">
  <use xlink:href="#del-icon"></use>
</svg></button></li>`;
	})}

</ol>`;
	}
}
CassisBookmarksList.define();

export class CassisBookmarksButton extends Customised(HTMLElement) {
	static tagName = "cassis-bookmark";
	signals() {
		return { locale: locale(), page: pageNumber(), count: pageCount() };
	}
	render({ locale, page }) {
		const locator = pageToLocator(page);
		return html`
			<button class="bookmark" @click="${() => saveBookmarkLocator(locator)}">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19 19" preserveAspectRatio="xMidYMid meet" role="img" class="icon bookmark-icon" aria-labelledby="bookmark-icon">
  <title id="bookmark-icon">Add a bookmark</title>
  <path d="M11.122 16.957A3.537 3.537 0 0013.638 18a3.55 3.55 0 002.52-1.043 3.541 3.541 0 001.044-2.518c0-.953-.372-1.846-1.044-2.518L10.45 6.229a2.42 2.42 0 00-1.712-.707c-.646 0-1.252.251-1.707.708a2.401 2.401 0 00-.71 1.709c0 .645.252 1.251.709 1.707l3.855 3.856a.302.302 0 00.426 0 .307.307 0 000-.428L7.454 9.221c-.341-.343-.532-.798-.532-1.283s.189-.941.532-1.285a1.803 1.803 0 011.284-.531c.484 0 .941.188 1.285.532l5.708 5.691c.56.557.867 1.299.867 2.092 0 .789-.307 1.531-.866 2.092a2.948 2.948 0 01-2.093.865 2.94 2.94 0 01-2.091-.865l-7.95-7.947A4.063 4.063 0 012.4 5.69c0-1.092.425-2.119 1.198-2.891a4.069 4.069 0 012.891-1.198c1.092 0 2.119.428 2.89 1.198l6.105 6.104a.302.302 0 00.428-.426L9.804 2.374C8.92 1.488 7.74 1 6.488 1s-2.431.488-3.316 1.374A4.663 4.663 0 001.799 5.69c0 1.253.488 2.431 1.374 3.316l7.949 7.951z"></path>
</svg>
    <span class="setting-text" id="bookmark-label">${locales.bookmark[locale]}</span>
  </button>`;
	}
}
CassisBookmarksButton.define();
